import React from 'react'

export default () => (
  <a className="ig-icon" href="https://www.instagram.com/spytajsavasich/" rel="noopener noreferrer" target="_blank">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43.327 43.327"><path d="M30.789,0H12.539A12.53,12.53,0,0,0,0,12.538v18.25A12.53,12.53,0,0,0,12.538,43.327h18.25A12.53,12.53,0,0,0,43.327,30.789V12.538A12.553,12.553,0,0,0,30.789,0Zm8.359,30.789a8.383,8.383,0,0,1-8.359,8.359H12.539A8.383,8.383,0,0,1,4.18,30.789V12.538a8.383,8.383,0,0,1,8.359-8.359h18.25a8.383,8.383,0,0,1,8.359,8.359Z" transform="translate(0 0)" /><path d="M41.736,30.8A10.936,10.936,0,1,0,52.675,41.737,10.936,10.936,0,0,0,41.736,30.8Zm0,17.693a6.757,6.757,0,1,1,6.757-6.757A6.757,6.757,0,0,1,41.736,48.493Z" transform="translate(-20.073 -20.073)" /><ellipse cx="2.543" cy="2.543" rx="2.543" ry="2.543" transform="translate(30.232 7.732)" /></svg>
  </a>
)



// WEBPACK FOOTER //
// ./src/components/Header/Ig.js